import React, {useState, useEffect, useRef} from 'react';
import SimpleBar from 'simplebar-react';

function SearchDropdownContainer(props) {
  const dropdown = useRef(null);

  const {
    search,
    selected,
    runTaxSearch,
    replaceSelected,
    taxSlug,
    closeRequest,
    defaultLabel,
    labelTitle,
    setSearch,
    setCloseRequest
  } = props;

  const [open, setOpen] = useState(false);

  let clearSearchVisible = '';

  function changeHandler(e) {
    e.preventDefault();

    setSearch(e.target.value);
    runTaxSearch(e.target.value);
  }

  function clearSearchTerm(e) {
    if (e) {
      e.preventDefault();
    }

    selected[taxSlug].forEach(id => {
      replaceSelected(id, taxSlug);
    });  
    setSearch('');
  }

  function toggleOpen(e) {
    if (e) {
      e.preventDefault();
    }
    setOpen(!open);
  }

  function close() {
    resetCloseRequest();
    setOpen(false);
  }

  function toggleClass() {
    const classString = open ? 'open' : '';
    return classString;
  }

  function resetCloseRequest() {
    if (closeRequest) {
      setCloseRequest(false);
    }
  }

  function outsideClick() {
    window.addEventListener('click', (e) => {
      const element = dropdown;
      if (!element.current.contains(e.target)) {
        close();
      }
    });
  }

  function keyHandler(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  if (search && search.length > 0) {
    clearSearchVisible = 'visible';
  }

  useEffect(() => {
    resetCloseRequest();
    outsideClick();
  }, []);

  useEffect(() => {
    if ((Object.keys(selected).length === 0 || selected[taxSlug].length === 0) && search) {
      clearSearchTerm();
    }
  }, [selected]);

  useEffect(() => {
    close();
  }, [closeRequest]);

  return(
    <div className={`dropdown-container ${toggleClass()}`} ref={dropdown}>
      <div className="filter-input">
        <input type="search" 
          placeholder={defaultLabel} 
          value={search} 
          onChange={(e) => {changeHandler(e)}}
          onFocus={(e) => {toggleOpen(e)}}
          onKeyPress={(e) => {keyHandler(e)}}
        ></input>

        <button 
          className={`clear-search ${clearSearchVisible}`}
          onClick={(e) => {clearSearchTerm(e)}}
          aria-label="Clear Search"
        >
          <span>+</span>
        </button>
      </div>
      <SimpleBar>
        {props.children}
      </SimpleBar>
    </div>
  )
}

export default SearchDropdownContainer;